<mat-card class="custom-dialog card">
  <div class="container">
    <h6>Authenticator</h6>

    <div class="btn-postion">
      @if(false) {
      <button mat-button (click)="enableSelection()">
        <img src="./assets/images/qr-scan-line.svg" alt="Scan" />
      </button> }
       @if(permissions_entity.modules.qr_code | permissions : permissions_entity.access.edit | async){
      <button mat-button (click)="addQQrCode();$event.stopPropagation()">
        <img src="./assets/images/add-large-line.svg" alt="Add" />
      </button>
    }
      @if(permissions_entity.modules.qr_code | permissions : permissions_entity.access.edit | async){
        <button mat-button (click)="edit();$event.stopPropagation()">
          <img src="./assets/images/edit-line.svg" alt="Edit" />
        </button>
      }  
      
    </div>
  </div>
  @if(showQrCode) {
    <div class="p-8 custom-scroll">
      <!-- Loop through 2FA data -->
      @if(qrCode?.length > 0){
        <div *ngFor="let item of qrCode; let i = index" (click)="$event.stopPropagation(); copyEntireDiv(item.code, i)" class="two-fa-item d-flex align-items-center justify-content-between" style="margin-bottom:16px;">
          <!-- Left: OTP Code -->
          <div>
            <h6>{{ item.issuer }}</h6>
            <span class="otp-code-text" [class.updated]="item.updated">{{ item.code }}</span>
          </div>
          <!-- Right: Circular Progress -->
          <div class="circle-wrapper">
            <svg class="progress-ring" width="50" height="50">
              <circle
                class="progress-ring__circle"
                stroke="#fd7e14"
                stroke-width="5"
                fill="transparent"
                r="10"
                cx="25"
                cy="25"
                [attr.stroke-dasharray]="item.circumference"
                [attr.stroke-dashoffset]="item.offset"
              ></circle>
            </svg>
          </div>
          <!-- Copied tooltip -->
          <span class="copied-tooltip" *ngIf="copiedIndex === i">Copied!</span>
        </div>
      }@else{
        <div class="two-fa-item">
          <h6>No 2FA data found</h6>
        </div>
      }
    </div>  
  }
  @if(editItem) {
  <div class="p-8 custom-scroll">
    @if(qrCode?.length > 0){
      <div *ngFor="let item of qrCode; let i = index" style="margin-bottom:16px;">
        <div (click)="$event.stopPropagation()" class="two-fa-item d-flex align-items-center justify-content-between">
          <!-- Left: OTP Code -->
          <div class="marketing-manager-content">
            <h6>{{ item.issuer }}</h6>
            <span class="otp-code-text" [class.updated]="item.updated">{{ item.code }}</span>

            <!-- Dropdown shown only for the active row -->
            @if(activeUserDropdownIndex === i) {
              <div class="form-field mt-8" (click)="$event.stopPropagation()">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-select #selectMarketingManager placeholder="All User"
                    [formControl]="marketingMangerMultiSelectControl"
                    [value]="selctedMarketingManagerArray()"
                    (selectionChange)="onMarketingManagerChange($event.value)"
                    (openedChange)="onMarketingManagerOpenedChange($event, selectMarketingManager)"
                    multiple>
                    <mat-option>
                      <ngx-mat-select-search [formControl]="marketingMangerCompanySearchCtrl"
                        placeholderLabel="Search User..."
                        noEntriesFoundLabel="No results">
                      </ngx-mat-select-search>
                    </mat-option>
                    @if ((!marketingManagerState.loading || marketingManagerState.data.length > 0) && marketingMangerCompanySearchCtrl.value === '') {
                      <mat-option [value]="'All'">
                        <mat-checkbox [checked]="
                            selctedMarketingManagerArray().includes('All') ||
                            selctedMarketingManagerArray().length === 0
                          ">
                          All User
                        </mat-checkbox>
                      </mat-option>
                    }
                    @for (manager of marketingManagerState.data; track manager.id) {
                      <mat-option [value]="manager.id">
                        <mat-checkbox [checked]="selctedMarketingManagerArray().includes(manager.id)">
                          {{ manager.name | titlecase }}
                        </mat-checkbox>
                      </mat-option>
                    }
                    @if (marketingManagerState.loading && marketingManagerState.data.length > 0) {
                      <mat-option class="loading-option" disabled>
                        <div style="display:flex;align-items:center;justify-content:center;">
                          <mat-spinner diameter="20" style="margin-right:8px"></mat-spinner>
                          <span>Loading more...</span>
                        </div>
                      </mat-option>
                    }
                    @if (marketingManagerState.loading && !marketingManagerState.data.length) {
                      <mat-option class="loading-option" disabled>
                        <div style="display:flex;align-items:center;justify-content:center;">
                          <mat-spinner diameter="20" style="margin-right:8px"></mat-spinner>
                          <span>Loading...</span>
                        </div>
                      </mat-option>
                    }
                    @if (!marketingManagerState.loading && marketingManagerState.data.length === 0) {
                      <mat-option class="loading-option" disabled>
                        <div style="display:flex;align-items:center;justify-content:center;">
                          <span>No Data Found...</span>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </div>

          <div class="marketing-manager-actions" style="gap: 12px;">
            @if(activeUserDropdownIndex === i) {
              <!-- Dropdown open: show Update + Cancel only -->
              <mat-icon
                class="cursor-pointer"
                color="primary"
                matTooltip="Save"
                (click)="updateMarketingManager(item, i); $event.stopPropagation()">
                save
              </mat-icon>

              <mat-icon
                class="cursor-pointer"
                color="warn"
                matTooltip="Cancel"
                (click)="cancelUserDropdown(); $event.stopPropagation()">
                cancel
              </mat-icon>
            } @else {
              <!-- Default: person icon + remove icon -->
              <mat-icon
                class="cursor-pointer"
                (click)="toggleUserDropdown(item, i); $event.stopPropagation()">
                person
              </mat-icon>

              <div (click)="deleteQr(item?.id)">
                <mat-icon class="text-danger">remove_circle</mat-icon>
              </div>
            }
          </div>
        </div>
      </div>
    }@else{
      <div class="two-fa-item">
        <h6>No 2FA data found</h6>
      </div>
    }
  </div>  
}
</mat-card>
@if(!showQrCode && !editItem) {
<mat-card class="add-qr-code">
  <button mat-button (click)="addQQrCode();$event.stopPropagation()">
    <mat-icon class="btn-cls">cancel</mat-icon>
  </button>
  <div class="p-8" *ngIf="!manualQrCode && !qrImage && !otpUrls">
    <div *ngIf="false" class="two-fa-item" (click)="enableSelection()">
      <p class="d-flex align-items-center justify-content-center text-center mt-10">Scan QR Code</p>
    </div>
    <div class="two-fa-item" (click)="manualEntry();$event.stopPropagation()">
      <p class="d-flex align-items-center justify-content-center text-center mt-10">Manual Entry</p>
    </div>
    <div class="two-fa-item" (click)="qrImageEntry();$event.stopPropagation()">
      <p class="d-flex align-items-center justify-content-center text-center mt-10">Import QR Image</p>
    </div>
    <div class="two-fa-item" (click)="OtpUrls();$event.stopPropagation()">
      <p class="d-flex align-items-center justify-content-center text-center mt-10">Import OTP URLs</p>
    </div>
  </div>
  @if(manualQrCode) {
    <ng-container>
      <mat-label>Issue</mat-label>
      <mat-form-field appearance="fill" class="full-width">
          <input matInput [(ngModel)]="issueValue" placeholder="Issue" (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </ng-container>
    <ng-container>
      <mat-label>Label</mat-label>
      <mat-form-field appearance="fill" class="full-width">
          <input matInput [(ngModel)]="labelValue" placeholder="Label" (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </ng-container>
    <ng-container>
      <mat-label>Secret</mat-label>
      <mat-form-field appearance="fill" class="full-width">
          <input matInput [(ngModel)]="secretValue" placeholder="Secret" (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </ng-container>
    <button mat-flat-button color="primary" (click)="forManual();$event.stopPropagation()">OK</button>
  }
  @if(qrImage) {
    <div class="two-fa-item" style="margin-top: 25px;" (click)="open_file.click()">
      <p class="d-flex align-items-center justify-content-center text-center mt-10">Import QR Image Backup</p>
    </div>
    <input type="file" style="display: none" #open_file (change)="selectFiles($event)" />
  }
  @if(otpUrls) {
    <ng-container>
      <mat-label>OTP URLs</mat-label>
      <mat-form-field appearance="fill" class="full-width">
          <input matInput [(ngModel)]="url" placeholder="OTP URLs" (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </ng-container>
    <button mat-flat-button color="primary" (click)="addOtpUrls();$event.stopPropagation()">OK</button>
  }
</mat-card>
}